<template>
<div class="chapter">
<div class="inner_page">
<a id="p7"></a>
<blockquote>
<p class="center ">T<span class="smallcaps">O</span> M<span class="smallcaps">EI</span>-L<span class="smallcaps">ING</span> L<span class="smallcaps">OO</span> &amp; S<span class="smallcaps">HEILA</span> D<span class="smallcaps">ONNELLY</span></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?42e8595f